<template>
  <v-container v-if="visible">
    <v-card v-if="flowStep === 'buttons'">
      <v-card-text>
        <v-container>
          <v-layout d-block>
            <v-flex v-for="option in statuses" v-bind:key="option.key" class="margin-flex">
              <v-btn large block @click="openCancelForm(option.key)">{{ option.label }}</v-btn>
            </v-flex>
            <v-flex class="margin-flex">
              <v-btn color="primary" large block @click="flowStep = 'date'">plan nieuwe afspraak</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <assignment-cancel-form v-if="flowStep === 'cancel'" :status="statusOption"></assignment-cancel-form>
    <v-card v-if="flowStep === 'date'">
      <v-card-text>
        <v-date-picker
          v-model="visitDate"
          landscape
          reactive
          :allowed-dates="allowedDates"
          class="mt-3"
          locale="nl-nl"
        ></v-date-picker>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="flowStep = 'time'">kies tijdstip</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="flowStep === 'time'">
      <v-card-text>
        <v-time-picker
          v-model="visitTime"
          landscape
          min="07:00"
          max="22:00"
          :allowed-minutes="allowedStep"
          format="24hr"
        ></v-time-picker>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="close">{{ buttonValue || "Sluiten" }}</v-btn>
      </v-card-actions>
    </v-card>
    <actual-planning-list v-if="showActualPlanningList" :select-city="activeAddress.address.city"></actual-planning-list>
  </v-container>
</template>
<style scoped>
.margin-flex {
  margin: 2em auto 2em;
}
</style>
<script>
import ActualPlanningList from "@/components/ActualPlanningList";
import AssignmentCancelForm from "@/components/AssignmentCancelForm";
import { mapGetters, mapActions } from "vuex";
import { visitService } from "@/services/address";

const flowItems = {
  BUTTONS: "buttons",
  SELECT_DATE: "date",
  SELECT_TIME: "time"
};

export default {
  name: "ScheduleVisit",
  components: {
    AssignmentCancelForm,
    ActualPlanningList
  },
  props: ["buttonValue", "visible", "showButtons"],
  data() {
    return {
      flowStep: flowItems.SELECT_DATE,
      visitTime: this.initTime(),
      visitDate: this.initDate(),
      statusOption: null,
      allowedStep: m => m % 15 === 0
    };
  },
  computed: {
    ...mapGetters(["activeAddress"]),
    visitTimeStore() {
      if (this.activeAddress.visitTime) {
        return this.activeAddress.visitTime;
      }
      return this.initTime();
    },
    visitDateStore() {
      if (this.activeAddress.visitDate) {
        return this.activeAddress.visitDate;
      }
      return this.initDate();
    },
    statuses() {
      return visitService.resolveStatuses();
    },
    showActualPlanningList() {
      return (this.flowStep === flowItems.SELECT_DATE || this.flowStep === flowItems.SELECT_TIME)
    }
  },
  methods: {
    ...mapActions(["scheduleVisit"]),
    allowedDates(date) {
      let checkDate = new Date(date);
      let now = new Date();
      if (checkDate < now && checkDate.getDay() !== now.getDay()) {
        return false;
      }
      return checkDate.getDay() !== 0;
    },
    updateFromStore() {
      this.visitDate = this.visitDateStore;
      this.visitTime = this.visitTimeStore;
    },
    cancelVisit() {
      this.setFlowToStart();
      this.$parent.closeScheduleVisitForm();
    },
    openCancelForm(option) {
      this.statusOption = option;
      this.flowStep = 'cancel';
    },
    initDate() {
      return new Date().toISOString().substring(0, 10);
    },
    initTime() {
      let date = new Date();
      let zoneOffset = date.getTimezoneOffset();
      let minutes = date.getMinutes();
      date.setMinutes(minutes - zoneOffset);
      date.setHours(date.getHours() + 1);
      date.setMinutes(0);
      return date.toISOString().substr(11, 5);
    },
    closeWithoutSave() {
      this.setFlowToStart();
      this.$parent.closeScheduleVisitForm();
    },
    close() {
      this.scheduleVisit({
        visitDate: this.visitDate,
        visitTime: this.visitTime
      });
      this.setFlowToStart();
      this.$parent.closeScheduleVisitForm();
    },
    setFlowToStart() {
      if (this.showButtons === "true") {
        this.flowStep = flowItems.BUTTONS;
      } else {
        this.flowStep = flowItems.SELECT_DATE;
      }
    }
  },
  watch: {
    // eslint-disable-next-line
    flowStep: function(newVisibiltyState, oldVisibiltyState) {
      if (newVisibiltyState === flowItems.SELECT_DATE) {
        this.updateFromStore();
      }
    }
  },
  created() {
    this.setFlowToStart();
    this.updateFromStore();
  }
};
</script>

